<template>
	<footer class="fixed bottom-0 left-0 flex items-center justify-center bg-white w-full h-12 border-t z-50">
		<span class="text-sm font-semibold">PLAN<span class="text-blue-300">TOGETHER</span></span>
	</footer>
</template>

<script>

export default {
	data() {
		return {}
	}
};
</script>